import React, { lazy } from 'react';
export function EmotionalOpening() {
  return <section className="bg-warm-light py-10 md:py-20 px-4" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        {/* Section heading */}
        <h2 className="font-serif text-[1.6rem] md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-3 md:mb-4 leading-[1.1]" data-id="element-86">
          If you love your dog, let me ask you{' '}
          <span className="italic text-soft-gold" data-id="element-87">one personal question</span>
        </h2>

        {/* Emotional copy */}
        <div className="font-sans text-[15px] md:text-lg text-gray-800 space-y-3 md:space-y-4 leading-[1.45] md:leading-relaxed max-w-2xl mx-auto" data-id="element-88">
          <p data-id="element-89">
            Do you ever feel like your dog looks amazing in real life… but your
            photos never quite capture it?
          </p>

          <p data-id="element-90">
            Not because your dog isn't photogenic. Not because your phone is
            bad. But because{' '}
            <span className="font-semibold text-warm-hero" data-id="element-91">
              no one ever showed you a simple system for photographing your dog
              the right way.
            </span>
          </p>

          <p data-id="element-92">
            You try to take the picture quickly. Your dog moves. The light is
            off. The angle feels awkward. The moment disappears.
          </p>

          <p className="italic text-gray-600 border-l-4 border-soft-gold pl-4 py-2 my-4 md:my-6 bg-cream/60 rounded-r-lg text-[14px] md:text-base" data-id="element-93">
            "That doesn't even show how beautiful they really are."
          </p>

          <p className="font-semibold text-[15px] md:text-lg text-warm-hero" data-id="element-94">
            Dog photography should not feel like random luck.
          </p>
        </div>
      </div>
    </section>;
}